const hasAccruedReports = (accrued) => {
  return {
    getAccruedCountFor(type) {
      return accrued.reduce((accumulator, report) => {
        return (report.type === type) ? (accumulator + 1) : accumulator;
      }, 0);
    },
    getHasReviewedEop() {
      // TODO
    },
  };
};

export default hasAccruedReports;
